import { render, staticRenderFns } from "./siteJakartaBoard.vue?vue&type=template&id=0e9e3e7a&"
import script from "./siteJakartaBoard.vue?vue&type=script&lang=js&"
export * from "./siteJakartaBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports